import Vue from 'vue'
import Vuelidate from 'vuelidate'
import * as apollo from '../utils/apollo'
import * as theme from '../utils/theme'
import * as general from '../utils/general'

export const ota = {
  apollo,
  theme,
  general
}

export default (_, inject) => {
  inject('ota', ota)
}

Vue.use(Vuelidate)

Vue.directive('click-outside', {
  bind (el, binding, vnode) {
    el.clickOutsideEvent = function (event) {
      // Check that click was outside the el and its children
      if (!(el === event.target || el.contains(event.target))) {
        // Call method provided in attribute value.
        vnode.context[binding.expression](event)
      }
    }
    document.body.addEventListener('click', el.clickOutsideEvent)
  },
  unbind (el) {
    document.body.removeEventListener('click', el.clickOutsideEvent)
  }
})
